import { render, staticRenderFns } from "./FilesAddButton.vue?vue&type=template&id=0a868f77&scoped=true&"
import script from "./FilesAddButton.vue?vue&type=script&lang=js&"
export * from "./FilesAddButton.vue?vue&type=script&lang=js&"
import style0 from "./FilesAddButton.vue?vue&type=style&index=0&id=0a868f77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a868f77",
  null
  
)

export default component.exports